import { render, staticRenderFns } from "./GreyProfilesPage.vue?vue&type=template&id=f8411a08&"
import script from "./GreyProfilesPage.vue?vue&type=script&lang=js&"
export * from "./GreyProfilesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports